module.exports = __webpack_public_path__ + "static/logo_white.17364c15.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo_white.png
// module id = 629
// module chunks = 35783957827783